<template>
    <kgr-loading v-if="loading" />
    <div v-else>
        <div>
            <div class="kgr-alert kgr-alert--info kgr-row">
                {{ tInfoText }}
            </div>
            <div class="kgr-row">
                <kgr-department-select
                    v-model="newRelation.department"
                    :club-id="clubId"
                    :disabled="loading"
                    exclude-if-basic-data-not-viewable
                />
            </div>
            <kgr-form-row
                :label="tLabelStart"
                :error="error"
                field-name="start"
            >
                <div
                    class="form-widget date-picker"
                    :class="{ invalid: (!newRelation.start || !isValidDateRange) }"
                >
                    <kgr-date-picker
                        v-model="newRelation.start"
                        :disabled="loading"
                    />
                </div>
            </kgr-form-row>
            <kgr-form-row
                :label="tLabelEnd"
                :error="error"
                field-name="end"
            >
                <div
                    class="form-widget date-picker"
                    :class="{ invalid: !isValidDateRange }"
                >
                    <kgr-date-picker
                        v-model="newRelation.end"
                        :disabled="loading"
                    />
                </div>
            </kgr-form-row>
            <hr class="kgr-separator" />
            <div class="kgr-row">
                <button
                    class="kgr-button"
                    @click="$emit('onClose')"
                >
                    {{ tButtonCancel }}
                </button>
                <button
                    class="kgr-button"
                    :disabled="!isValidData || !isValidDateRange"
                    @click="updateTeamRelations(true)"
                >
                    <kgr-loading
                        v-if="loading"
                        inline
                    />
                    <span v-else>{{ tButtonExecuteTestRun }}</span>
                </button>
                <button
                    class="kgr-button kgr-button--danger"
                    :disabled="!isValidData || !isValidDateRange"
                    @click="updateTeamRelations(false)"
                >
                    <kgr-loading v-if="loading" />
                    <span v-else>{{ tButtonExecute }}</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { isBefore, parse } from '@legacy/js/date/date-fns.js'
import BatchDepartmentMemberRelation from './BatchDepartmentMemberRelation.js';
import DatePicker from '../../../../../common/form/picker/DatePicker';
import DepartmentSelect from '../../../../../common/form/select/DepartmentSelect.vue';
import Error from '../../../../../../js/model/Error';
import FormRow from '../../../../../common/form/FormRow';
import Loading from '../../../../../common/Loading.vue';

export default {
    components: {
        'kgr-department-select': DepartmentSelect,
        'kgr-date-picker': DatePicker,
        'kgr-form-row': FormRow,
        'kgr-loading': Loading,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        listId: {
            type: Number,
            required: true,
        },
        entityIds: {
            type: Array,
            required: true,
        },
        loading: {
            type: Boolean,
            required: true,
        },
        savedActionData: {
            type: Object,
            required: false,
            default: () => null
        }
    },
    data() {
        return {
            newRelation: new BatchDepartmentMemberRelation(),
            error: new Error()
        };
    },
    computed: {
        isValidDateRange() {
            if (!this.newRelation.end) {
                return true;
            }
            return isBefore(parse(this.newRelation.start, 'dd.MM.yyyy', new Date()), parse(this.newRelation.end, 'dd.MM.yyyy', new Date()));
        },
        isValidData() {
            return this.newRelation.isValid();
        },
        tButtonCancel() {
            return this.$t('cancel');
        },
        tLabelStart() {
            return this.$t('Startdatum');
        },
        tLabelEnd() {
            return this.$t('Enddatum');
        },
        tInfoText() {
            if(this.newRelation.start && this.newRelation.department) {
                return this.$t('Lists.actions.DepartmentAssignment.infoTextComplete', {count: this.entityIds.length, department: this.newRelation.department.name, startDate: this.newRelation.start });
            }
            return this.$t('Lists.actions.DepartmentAssignment.infoText', {count: this.entityIds.length });
        },
        tButtonExecute() {
            return this.$t('Ausführen');
        },
        tButtonExecuteTestRun() {
            return this.$t('Lists.actions.executeTestRun');
        },
    },
    mounted() {
        this.assignDefaultData();
    },
    updated() {
        this.assignDefaultData();
    },
    methods: {
        updateTeamRelations(isTestRun) {
            if(!this.newRelation.isValid())  {
                return;
            }
            this.$emit('executeAction', this.newRelation, isTestRun);
        },
        assignDefaultData() {
            this.newRelation.ids = this.entityIds;
            if(this.savedActionData !== null && this.savedActionData instanceof BatchDepartmentMemberRelation) {
                this.newRelation = this.savedActionData
            }
        }
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
